import { CombinedError, useQuery } from 'urql';
import { GraphqlOperations } from './../operations';
import { Query, User } from './../types/types.d';

export const useUserPhoneNumber = (): {
  phoneNumber?: string;
  fetching: boolean;
  error?: CombinedError;
} => {
  const result = useQuery<Query>({
    query: GraphqlOperations.queries.getUserPhoneNumber.queryString,
  })[0];

  const { data, fetching, error } = result;
  const user = data?.getUser as User;
  const phoneNumber = user?.phone;

  return {
    phoneNumber,
    fetching,
    error,
  };
};
